// extracted by mini-css-extract-plugin
export default {"container":"SettingsContent_container__gnXDq","content":"SettingsContent_content__ExC2Y"};